import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { changeDataToDDMMYYYY } from '../../../utils/Date/SupportDate.js';
import { coverBranchIDToFullName } from '../../../utils/Branch/SupportBranch.js'
import * as bookingApi from '../../../api/booking';
import { useParams } from "react-router-dom/cjs/react-router-dom.min.js";

function MakePickUpBoardDemo() {
    const [guestName, setGuestName] = useState("");
    const [fileName, setFileName] = useState("");
    const [fontSize, setFontSize] = useState(120);
    const [pickupSub, setPickupSub] = useState(false);
    const [isHCMAreaBranch, setIsHCMAraBranch] = useState(false);

    const [pickupData, setPickupData] = useState({
        flight: "",
        date: "",
        branchID: "",
        time: "",
    });

    const { idRoom } = useParams();
    const auth = useSelector(state => state.auth);
    const token = useSelector(state => state.token);
    const { branchID } = auth.user;

    useEffect(() => {
        var guestNameList;
        var firstNameGuest
        if(branchID) {
            const loadBooking = async () => {
                const dataResult = await bookingApi.takeBookingDataByIdWithType(branchID, idRoom, "sign", token);
                if(dataResult) {

                    const { listGuestSelect } = dataResult.data.data;
                    listGuestSelect.forEach((item, index) => {
                        if(index === 0) {
                            guestNameList = (item.gender ? "Ms." : "Mr.")+ item.name; 
                            firstNameGuest = guestNameList;
                        }  else guestNameList = guestNameList + "&\n" + (item.gender ? "Ms." : "Mr.") + item.name
                    })

                    if (listGuestSelect.length === 1) setFontSize(120);
                    if (listGuestSelect.length === 2) setFontSize(100);
                    if (listGuestSelect.length === 3) setFontSize(90);
                    if (listGuestSelect.length === 4) setFontSize(60);

                    const fileNameSave =  ` (${changeDataToDDMMYYYY(dataResult.data.data.listSchedule[0].checkin).slice(0, 2)}-${changeDataToDDMMYYYY(dataResult.data.data.listSchedule[0].checkout)})`;
                    
                    if(branchID === 1 || branchID === 4 || branchID === 9 ) {
                        setIsHCMAraBranch(true);
                        setPickupSub(true);
                    }

                    setGuestName(guestNameList);
                    setPickupData({
                        flight: dataResult.data.data2.pickUp.flight, 
                        time: dataResult.data.data2.pickUp.time,
                        branchID: branchID,
                        date: changeDataToDDMMYYYY(dataResult.data.data.listSchedule[0].checkin)
                    });
                    // setFileNameSave("Pick_up_" + [firstNameGuest]);
                    setFileName("Pick_up_" + firstNameGuest + fileNameSave);
                    document.title = "Pick_up_" + firstNameGuest + fileNameSave
                }
            }

            loadBooking()
        }

    }, [token, branchID, idRoom])

    // height:'2100mm',
    return (
        <div className="d-flex">
        
        <div className={branchID === 15 ? "a4-pageHCM" : "a4-page"} style={{  margin: '20px auto', padding :'5mm', width: '300mm', boxShadow:'0 0 5px rgba(0,0,0,0.2)', boxSizing:'border-box'}}>
            <div style={{ border: '1px solid black', width: '100%', height: '730px',  }}>
                <div style={{ border: '0.8px solid black', margin: '8px', height: '710px' }} className="no-border">
                    <div className="d-flex mt-3 ml-4">
                        <img src="https://database.azumayareport.com/img/logo/logo_az.png" 
                                alt="logo." class="img-responsive logo" 
                                style={{width: '350px', height:'150px'}}></img>
                        <div style={{margin:'auto'}}>
                          <div style={{ fontSize: '5rem', marginTop: '6px', fontWeight:'600'}}>AZUMAYA HOTEL</div>
                          <div style={{ fontSize: '5rem', fontWeight:'600'}}>{coverBranchIDToFullName(Number(branchID)).toUpperCase()}</div>
                        </div>
                    </div>

                    <textarea style={{
                        marginTop: '14px',
                        maxHeight: '420px',
                        minHeight: '420px',
                        height: '420px',
                        width: '90%',
                        fontSize: fontSize,
                        padding: 0,
                        textAlign: 'center',
                        fontWeight: 'bold'
                    }}
                        onChange={e => setGuestName(e.target.value)}
                        value={guestName}
                    > </textarea>

                    <div className="d-flex justify-content-center">
                        <div style={{ fontSize: '4.5rem', marginTop: '10px' }}>
                                            {`PICK UP: ${pickupData ? pickupData.flight : ""} - Time: ${pickupData ? pickupData.time + " - Date: "+ pickupData.date
                                             : ""}`}</div>
                        {/* <div style={{ fontSize: '3rem', marginTop: '10px' }}>{"- Date: "+ changeDataToDDMMYYYY(makeRoomOnState.listSchedule[0].checkin)}</div> */}
                    </div>

                </div>
            </div>

            <div style={{  width: '100%',  marginTop: '60px', paddingLeft:'45px' }} className={(isHCMAreaBranch && pickupSub) ? "hiddenNormal" : "no-print"}>
                <div style={{ margin: '8px'}}></div>
                    <div style={{fontSize:'10rem', textAlign: 'left'}}>私は車を取りに行って</div>        
                    <div style={{fontSize:'10rem', textAlign: 'left'}}>来ますので、こちらで</div>                             
                    <div style={{fontSize:'10rem', textAlign: 'left'}}>少々お待ちください。</div>                             
                </div>
        </div >


        <div  style={{ backgroundColor: 'yellow', height: '100px', marginTop:'14%' }} className="no-print">
                <div className="mt-2" style={{ backgroundColor: 'yellow' }}>
                    <div className="mb-2">Set Font Size</div>
                    <input
                        type="number"
                        onChange={e => setFontSize(Number(e.target.value))}
                        onBlur={e => setFontSize(e.target.value)}
                        style={{ width: '70px' }}
                        value={fontSize} />
                    <div>
                        <button className="btn btn-primary" style={{}}
                            onClick={() => setFontSize(Number(fontSize) + 1)}>Up</button>
                        <button className="btn btn-warning ml-2"
                            onClick={() => setFontSize(Number(fontSize) - 1)}
                            style={{}}>Down</button>
                        <button className="btn btn-success mt-2 mb-3"
                            onClick={() => setFontSize(80)}
                            style={{}}>Reset (80)</button>
                    </div>
                </div>

                <div className="mt-2 mb-3 pt-3 pb-2" style={{ backgroundColor: 'yellow', }}>
                    <div className="">File name :</div>
                    <textarea
                        className="mb-2"
                        maxlength="100"
                        value={fileName}
                        onChange={e => setFileName(e.target.value)}
                        style={{ height: "30px", width: '100%' }} ></textarea>
                </div>

                { isHCMAreaBranch && 
                    <div style={{ marginLeft: '22px', textAlign: 'left' }}>

                    <input
                        class="form-check-input"
                        type="checkbox"
                        value={pickupSub}
                        checked={pickupSub}
                        style={{fontSize:'1.4rem'}}
                        onChange={() => setPickupSub(!pickupSub)}
                        id={"pickupSub"}
                    />
                    <label className="form-check-label ml-2" for={"pickupSub"} style={{fontSize:'1.3rem'}}>
                        Add Waiting drive on page 2
                    </label>
                </div>
                } 

                <div className="mt-2 mb-3 pt-3 pb-2">
                    <button className="btn btn-primary"
                        style={{ fontSize: '1.2rem' }}
                        onClick={() => window.print()}>
                        Download PDF
                    </button>
                    {/* <button className="btn btn-danger ml-2" style={{ fontSize: '1.2rem' }}
                        onClick={() => props.onClose()}>
                        Cancel
                    </button> */}
                </div>
            </div>

            <style>{`
                body {
                    margin: 0;
                        padding: 20px;
                        background: #ccc;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 100vh;
                    }

                    .a4-page {
                        margin-top: 12px
                        width: 297mm;
                        height: 210mm;
                        background: white;
                        padding: 20mm;
                        box-sizing: border-box;
                        box-shadow: 0 0 10px rgba(0,0,0,0.3);
                        overflow: hidden;
                    }

                    .a4-pageHCM {
                        margin-top: 12px
                        width: 297mm;
                        height: 210mm;
                        background: white;
                        padding: 20mm;
                        box-sizing: border-box;
                        box-shadow: 0 0 10px rgba(0,0,0,0.3);
                        overflow: hidden;
                    }

                    .hiddenNormal {
                       display: none;
                    }

                    @media print {
                        /* CSS print */
                        @page {
                            size: A4 landscape;
                            margin: 0;
                        }

                        .no-border {
                            border: none;
                        }

                        .no-print {
                            border: none;
                        }

                        .a4-page {
                            margin: 0;
                            width: 297mm;
                            height: 200mm;
                            padding: 20mm;
                            page-break-before: always;
                        }

                        .a4-pageHCM {
                            margin: 0;
                            width: 297mm;
                            height: 200mm;
                            padding: 20mm;
                            margin-top: 12px
                            background: white;
                            box-sizing: unset;
                            box-shadow: unset;
                            overflow: unset;
                        }
                                
                        .hiddenNormal {
                          display: block;
                         }

                        .makeRoom-checkInOut_input {
                            background-color: white;
                            text-align: center;
                        }

                        .pmrq-hidden-when-have-not-print {
                            display: block;
                        }

                        textarea {
                            border: none;
                            resize: none;
                            overflow: hidden;
                        }
                }
            `}

        </style>
        </div>
    )
}

export default MakePickUpBoardDemo
